<form [formGroup]="formGroupBenutzer()">

  <div class="flex-container">
    <div style="flex: 12">
      <label>Anrede</label>
      <mat-form-field>
        <mat-select formControlName='anrede'>
          @for (anrede of anredeEnums; track anrede) {
            <mat-option [value]="anrede.value">
              {{ anrede.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="flex-container">
    <div style="flex: 6">
      <label>{{'registrierung.benutzerdaten.label_vorname'|translate}}</label>
      <mat-form-field>
        <input matInput formControlName="vorname" placeholder="{{'registrierung.benutzerdaten.label_vorname'|translate}}" />
        @if ((formGroupBenutzer().touched || formGroupBenutzer().dirty) && formGroupBenutzer().controls['vorname'].errors) {
          <mat-error>
            <mat-icon svgIcon="basics:error"></mat-icon>
            <span >{{'registrierung.benutzerdaten.vorname_pflicht'|translate}}</span>
          </mat-error>
        }

      </mat-form-field>
    </div>
    <div style="flex: 6">
      <label>{{'registrierung.benutzerdaten.label_nachname'|translate}}</label>
      <mat-form-field>
        <input matInput formControlName="nachname" placeholder="{{'registrierung.benutzerdaten.label_nachname'|translate}}" />
        @if ((formGroupBenutzer().touched || formGroupBenutzer().dirty) && formGroupBenutzer().controls['nachname'].errors) {
          <mat-error>
            <mat-icon svgIcon="basics:error"></mat-icon>
            <span >{{'registrierung.benutzerdaten.nachname_pflicht'|translate}}</span>
          </mat-error>
        }

      </mat-form-field>
    </div>
  </div>

  <div class="flex-container">
    <div style="flex: 6">
      <label>{{'registrierung.benutzerdaten.label_telefon'|translate}}</label>
      <mat-form-field>
        <input matInput formControlName="telefon" placeholder="{{'registrierung.benutzerdaten.label_telefon'|translate}}" />
        @if ((formGroupBenutzer().touched || formGroupBenutzer().dirty) && formGroupBenutzer().controls['telefon'].errors) {
          <mat-error>
            <mat-icon svgIcon="basics:error"></mat-icon>
            <span >{{'registrierung.benutzerdaten.telefon_pflicht'|translate}}</span>
          </mat-error>
        }

      </mat-form-field>
    </div>
  </div>


  <div class="flex-container">
    <div style="flex: 6">
      <label>{{'registrierung.benutzerdaten.label_email'|translate}}</label>
      <mat-form-field>
        <input matInput formControlName="email" placeholder="{{'registrierung.benutzerdaten.label_email'|translate}}" />
        @if ((formGroupBenutzer().touched || formGroupBenutzer().dirty) && formGroupBenutzer().controls['email'].errors) {
          <mat-error>
            <mat-icon svgIcon="basics:error"></mat-icon>
            <span >{{'registrierung.benutzerdaten.email_pflicht'|translate}}</span>
          </mat-error>
        }

      </mat-form-field>
    </div>
    <div style="flex: 6">
      <label>{{'registrierung.benutzerdaten.label_email_wdh'|translate}}</label>
      <mat-form-field>
        <input matInput formControlName="email_wdh" placeholder="{{'registrierung.benutzerdaten.label_email_wdh'|translate}}" />
        @if ((formGroupBenutzer().touched || formGroupBenutzer().dirty) && formGroupBenutzer().controls['email_wdh'].errors) {
          <mat-error>
            <mat-icon svgIcon="basics:error"></mat-icon>
            <span >{{'registrierung.benutzerdaten.email_pflicht'|translate}}</span>
          </mat-error>
        }
      </mat-form-field>
        @if (
          (formGroupBenutzer().get('email')?.value?.length || 0) > 0 &&
          (formGroupBenutzer().get('email_wdh')?.value?.length || 0) > 0 &&
          formGroupBenutzer().get('email')?.value !== formGroupBenutzer().get('email_wdh')?.value
          ) {
          <div style="font-size: 14px; margin-left: 12px">
            <mat-error>
              <mat-icon svgIcon="basics:error" style="width: 18px; vertical-align: middle; margin-right: 4px;"></mat-icon>
              <span style="vertical-align: middle;">{{'registrierung.benutzerdaten.email_wdh_fehler'|translate}}</span>            </mat-error>
          </div>
        }

    </div>
  </div>

</form>
